import { Typography, Container } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import MainFooter from '../../components/layout/MainFooter';
import LoginForm from '../../components/auth/LoginForm';
import { login } from '../../actions/auth';

import { connect } from 'react-redux';

const Login = ({ isAuthenticated, login, errors }) => {
  //Redirect
  if(isAuthenticated){
    return <Navigate to="/home" />
  }

  return (
    <Container component="main" maxWidth="lg">
      <Grid container spacing={{ lg: 5 }} mt={{ xs: 6, md: 0 }}>
        <Grid 
          className="logo-login"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
          size={{ md: 6 }}
        >
          <img width="400" src="/logo-os 24.svg" alt="oneService" />
          <Typography variant='h3' color="primary" mt={3}>
            "Invierte en el futuro de los servicios."
          </Typography>
        </Grid>
        <LoginForm
          login={login}
          errors={errors}
        />
      </Grid>
      <MainFooter />
    </Container>
  );
}

Login.protoTypes = {
  isAuthenticated: PropTypes.bool,
  login: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  errors: state.auth.errors
});

export default connect(mapStateToProps, { login })(Login);